import type { Row, FilterFn } from '@tanstack/react-table';

import { CaseLevel1Code } from 'shared/constants/common-cases';
import type { Option } from 'shared/components/TableFilterSelect';
import type { Option as OptionDTO } from 'shared/models/common';

import type { UserCommonCase } from '../../types';

function toOption(dto: OptionDTO): Option<CaseLevel1Code> {
  return {
    label: dto.Label ?? '',
    value: dto.Value ?? 0,
  };
}

function isUniqueOption<T extends string | number>(
  checkedOption: Option<T>,
  list: Option<T>[]
) {
  return !list.some((option) => option.value === checkedOption.value);
}

export function getCaseLevel1Options(
  rows: Row<UserCommonCase>[]
): Option<CaseLevel1Code>[] {
  return rows.reduce((acc, row) => {
    if (row.original.CaseLevel1) {
      const option = toOption(row.original.CaseLevel1);

      if (isUniqueOption(option, acc)) acc.push(option);
    }

    return acc;
  }, [] as Option<CaseLevel1Code>[]);
}

export const selectCaseLevel1FilterFn: FilterFn<UserCommonCase> = (
  row,
  _columnId,
  value
) => {
  if (Array.isArray(value) && value.length) {
    return value.includes(row.original.CaseLevel1?.Value);
  }

  return false;
};
